import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { showChatBot } from '@om/redux/actions/publicWeb/chatBot';
import { OmModal } from '@om/component-library-react';
import { createStructuredSelector } from 'reselect';
import { getModalType } from '@om/redux/selectors/fundDeclarations/fundDeclarations';
import { clearModalValue } from '@om/redux/actions/fundDeclarations/fundDeclarations';
import './FundDeclarationModal.scss';

const FundDeclarationModal = () => {
    const { modalType } = useSelector(
        createStructuredSelector({
            modalType: getModalType,
        })
    );

    const dispatch = useDispatch();

    return (
        <div className="fund-declaration-modal">
            <OmModal
                onOnClose={() => {
                    dispatch(showChatBot());
                    dispatch(clearModalValue());
                }}
                isCentered={true}
                overlayName="fund-declaration-modal"
            >
                <div slot="modal-content">
                    {modalType && modalType === 'dividends' && (
                        <div>
                            <p>
                                What are <strong>Dividends?</strong>
                            </p>
                            <p>
                                Dividends are regular payments (typically
                                annually) of profits by a company to its
                                shareholders.
                            </p>
                        </div>
                    )}
                    {modalType && modalType === 'interest' && (
                        <div>
                            <p>
                                What is <strong>Interest?</strong>
                            </p>
                            <p>
                                The portion of distribution that is made up of
                                interest which is part of the investment growth.
                            </p>
                        </div>
                    )}
                    {modalType && modalType === 'distribution' && (
                        <div>
                            <p>
                                What are <strong>Distibutions?</strong>
                            </p>
                            <p>
                                A distribution is the income that is paid to the
                                unit trust investor at least once a year.
                            </p>
                        </div>
                    )}
                </div>
            </OmModal>
        </div>
    );
};

export default FundDeclarationModal;
